var map = {
	"./agriculture.png": 8964,
	"./animals.png": 8464,
	"./babies.png": 9171,
	"./beauty.png": 9523,
	"./electronics.png": 2442,
	"./equipment.png": 6507,
	"./fashion.png": 4311,
	"./girls.png": 690,
	"./hobbies.png": 9267,
	"./home.png": 78,
	"./jiji logo.png": 5666,
	"./jobs.png": 3795,
	"./jobseekers.png": 8268,
	"./main_how_to_buy (1).jpg": 1764,
	"./main_how_to_buy.jpg": 8634,
	"./main_safety_tips.jpg": 4522,
	"./man.png": 9159,
	"./mobile.png": 1485,
	"./real-estate.png": 5798,
	"./repair.png": 2820,
	"./services.png": 2515,
	"./vehicles.png": 6032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;